import { render, staticRenderFns } from "./indexPage.vue?vue&type=template&id=0a6318ef&scoped=true"
import script from "./indexPage.vue?vue&type=script&setup=true&lang=js"
export * from "./indexPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./indexPage.vue?vue&type=style&index=0&id=0a6318ef&prod&scoped=true&lang=css"
import style1 from "./indexPage.vue?vue&type=style&index=1&id=0a6318ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6318ef",
  null
  
)

export default component.exports